(function () {
  'use strict';

  var VERSION = 'v7';
  var PRIMARY_ROOT = '/';
  var productCache = new Map();
  var patchTimer = null;

  document.documentElement.setAttribute('data-kalles-multilang-swatches', VERSION);

  function normalizeText(value) {
    return String(value == null ? '' : value).trim();
  }

  function lower(value) {
    return normalizeText(value).toLocaleLowerCase();
  }

  // Close enough to Shopify's `handle` filter for the color names used by Kalles.
  function handleize(value) {
    return normalizeText(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function replaceBgColorClass(element, originalValue) {
    if (!element || !originalValue) return;
    Array.prototype.slice.call(element.classList).forEach(function (cls) {
      if (cls.indexOf('bg_color_') === 0) element.classList.remove(cls);
    });
    element.classList.add('bg_color_' + handleize(originalValue));
  }

  function getPrimaryProduct(handle) {
    if (!handle) return Promise.reject(new Error('Missing product handle'));
    if (productCache.has(handle)) return productCache.get(handle);

    var url = new URL(PRIMARY_ROOT + 'products/' + encodeURIComponent(handle) + '.js', window.location.origin);
    var promise = fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product JSON ' + response.status + ': ' + handle);
      return response.json();
    }).catch(function (error) {
      productCache.delete(handle);
      throw error;
    });

    productCache.set(handle, promise);
    return promise;
  }

  function uniqueOptionValues(product, optionIndex, availableOnly) {
    var values = [];
    var seen = new Set();
    (product.variants || []).forEach(function (variant) {
      if (availableOnly && !variant.available) return;
      var value = variant.options && variant.options[optionIndex];
      if (value == null || seen.has(value)) return;
      seen.add(value);
      values.push(value);
    });
    return values;
  }

  function productHandleFromCard(card) {
    try {
      var raw = card.getAttribute('data-product-options');
      if (raw) {
        var data = JSON.parse(raw);
        if (data && data.handle) return data.handle;
      }
    } catch (e) {}

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var match = link.getAttribute('href').match(/\/products\/([^?/#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function productHandleFromLocation() {
    var match = window.location.pathname.match(/\/products\/([^?/#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function parseColorOptions(box) {
    try {
      return JSON.parse(box.getAttribute('data-color-options') || '{}');
    } catch (e) {
      return {};
    }
  }

  function realCardSwatches(box) {
    return Array.prototype.slice.call(box.querySelectorAll('.t4s-pr-color__item')).filter(function (item) {
      return !item.classList.contains('is--colors-more') && !!item.querySelector('.t4s-pr-color__name');
    });
  }

  function chooseCanonicalSequence(product, optionIndex, swatchCount, data) {
    var all = uniqueOptionValues(product, optionIndex, false);
    var available = uniqueOptionValues(product, optionIndex, true);

    if (swatchCount === all.length) return all;
    if (swatchCount === available.length) return available;

    // Kalles can render all values while `color_count` only counts available values.
    if (data && Array.isArray(data.color_variants) && data.color_variants.length === all.length && swatchCount === data.color_variants.length) {
      return all;
    }
    if (data && Array.isArray(data.color_variants_avai) && data.color_variants_avai.length === available.length && swatchCount === data.color_variants_avai.length) {
      return available;
    }

    return null;
  }

  function findVariantForOriginalColor(product, optionIndex, originalValue) {
    var variants = (product.variants || []).filter(function (variant) {
      return variant.options && variant.options[optionIndex] === originalValue;
    });
    return variants.find(function (variant) { return variant.available; }) || variants[0] || null;
  }

  function variantImageInfo(variant) {
    if (!variant) return null;
    var image = variant.featured_image || (variant.featured_media && variant.featured_media.preview_image) || null;
    if (!image) return null;
    if (typeof image === 'string') return { src: image };
    return {
      src: image.src || image.url || '',
      id: image.id || 0,
      aspect_ratio: image.aspect_ratio || (image.width && image.height ? image.width / image.height : '')
    };
  }

  async function patchCollectionCard(card) {
    if (!card || !card.matches('[data-product-options]')) return;
    var box = card.querySelector('[data-color-options]');
    if (!box) return;

    var items = realCardSwatches(box);
    // Kalles initially renders 3 loading placeholders. Wait for its own ProductItem renderer.
    if (!items.length) return;

    var handle = productHandleFromCard(card);
    if (!handle) return;

    var optionIndex = parseInt(box.getAttribute('data-color-index'), 10);
    if (!Number.isFinite(optionIndex)) return;

    var product;
    try {
      product = await getPrimaryProduct(handle);
    } catch (error) {
      console.warn('[Kalles multilang swatches] primary product fetch failed:', handle, error);
      return;
    }

    var data = parseColorOptions(box);
    var canonical = chooseCanonicalSequence(product, optionIndex, items.length, data);
    if (!canonical) {
      console.warn('[Kalles multilang swatches] cannot safely align color order:', handle, items.length);
      return;
    }

    items.forEach(function (item, index) {
      var originalValue = canonical[index];
      var valueEl = item.querySelector('.t4s-pr-color__value');
      replaceBgColorClass(valueEl, originalValue);
      item.setAttribute('data-kalles-original-color', originalValue);

      // Repair Kalles' undefined variant id when a color has no featured image.
      var variant = findVariantForOriginalColor(product, optionIndex, originalValue);
      if (variant && variant.id) item.setAttribute('data-vid', String(variant.id));

      // If Shopify's Ajax product JSON exposes a variant image, make the Kalles swatch clickable too.
      var image = variantImageInfo(variant);
      if (image && image.src) {
        item.setAttribute('data-imgid', '0');
        item.setAttribute('data-img', image.src);
        if (image.aspect_ratio) item.setAttribute('data-ratio', String(image.aspect_ratio));
      }
    });

    box.setAttribute('data-kalles-multilang-patched', VERSION);
  }

  function currentOptionName(optionEl, fallback) {
    var title = optionEl.querySelector('.t4s-swatch__title > span');
    if (!title) return fallback || '';
    for (var i = 0; i < title.childNodes.length; i++) {
      var node = title.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && normalizeText(node.nodeValue)) {
        return normalizeText(node.nodeValue).replace(/:\s*$/, '');
      }
    }
    return fallback || '';
  }

  function selectedCurrentValue(optionEl) {
    var selected = optionEl.querySelector('[data-swatch-item].is--selected');
    if (selected) return normalizeText(selected.getAttribute('data-value') || selected.textContent);
    var current = optionEl.querySelector('[data-current-value]');
    return current ? normalizeText(current.textContent) : '';
  }

  function refreshKallesGallery() {
    try {
      var jq = window.jQuery_T4NT || window.jQuery;
      if (!jq) return;
      jq('[data-main-media].flickityt4s-enabled').trigger('update.flickityt4s');
    } catch (e) {}
  }

  async function patchProductPage() {
    var handle = productHandleFromLocation();
    if (!handle) return;

    var colorOptions = Array.prototype.slice.call(document.querySelectorAll('.t4s-swatch__option.is-t4s-style__color[data-id]'));
    if (!colorOptions.length) return;

    var product;
    try {
      product = await getPrimaryProduct(handle);
    } catch (error) {
      console.warn('[Kalles multilang swatches] primary product fetch failed:', handle, error);
      return;
    }

    colorOptions.forEach(function (optionEl) {
      var optionIndex = parseInt(optionEl.getAttribute('data-id'), 10);
      if (!Number.isFinite(optionIndex)) return;

      var items = Array.prototype.slice.call(optionEl.querySelectorAll('[data-swatch-item]'));
      var canonical = uniqueOptionValues(product, optionIndex, false);
      if (!items.length || items.length !== canonical.length) return;

      var currentByOriginal = new Map();
      items.forEach(function (item, index) {
        var originalValue = canonical[index];
        var currentValue = normalizeText(item.getAttribute('data-value') || item.textContent);
        currentByOriginal.set(lower(originalValue), currentValue);
        replaceBgColorClass(item, originalValue);
        item.setAttribute('data-kalles-original-color', originalValue);
      });

      var canonicalOptionName = product.options && product.options[optionIndex] ? product.options[optionIndex].name : '';
      var localizedOptionName = currentOptionName(optionEl, canonicalOptionName);
      var canonicalNameLower = lower(canonicalOptionName);
      var localizedNameLower = lower(localizedOptionName);

      // Legacy Kalles group-media ALT values such as Couleur_Navy must follow the translated
      // option values at runtime, while colors.css must keep using the primary/original key.
      var grouped = Array.prototype.slice.call(document.querySelectorAll('[data-grname][data-grpvl]'));
      grouped.forEach(function (media) {
        var groupName = lower(media.getAttribute('data-grname'));
        var groupValue = lower(media.getAttribute('data-grpvl'));
        if (groupName !== canonicalNameLower) return; // t4option/localized groups already work.
        var localizedValue = currentByOriginal.get(groupValue);
        if (!localizedValue) return;
        media.setAttribute('data-grname', localizedNameLower);
        media.setAttribute('data-grpvl', lower(localizedValue));
      });

      var selected = lower(selectedCurrentValue(optionEl));
      if (selected && localizedNameLower) {
        document.querySelectorAll('[data-main-slide][data-grname="' + CSS.escape(localizedNameLower) + '"]').forEach(function (media) {
          media.classList.toggle('is--media-hide', lower(media.getAttribute('data-grpvl')) !== selected);
        });
        document.querySelectorAll('.t4s-carousel__nav-item[data-grname="' + CSS.escape(localizedNameLower) + '"]').forEach(function (media) {
          media.classList.toggle('is--media-hide', lower(media.getAttribute('data-grpvl')) !== selected);
        });
      }
    });

    refreshKallesGallery();
  }

  async function patchAll() {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-product-options]'));
    await Promise.all(cards.map(function (card) { return patchCollectionCard(card); }));
    await patchProductPage();
  }

  function schedulePatch() {
    clearTimeout(patchTimer);
    patchTimer = setTimeout(function () {
      patchAll().catch(function (error) {
        console.warn('[Kalles multilang swatches] patch failed:', error);
      });
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePatch, { once: true });
  } else {
    schedulePatch();
  }

  window.addEventListener('load', function () {
    setTimeout(schedulePatch, 250);
    setTimeout(schedulePatch, 1200);
  });

  document.addEventListener('shopify:section:load', schedulePatch);
  document.addEventListener('shopify:section:select', schedulePatch);

  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      if (mutation.type !== 'childList') return false;
      var target = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      return target && (target.closest('[data-color-options]') || target.closest('.t4s-swatch') || target.querySelector && (target.querySelector('[data-color-options]') || target.querySelector('.t4s-swatch')));
    });
    if (relevant) schedulePatch();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.KallesMultilangSwatchesDebug = {
    version: VERSION,
    patchAll: patchAll,
    cache: productCache,
    handleize: handleize
  };
})();
